import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.service';
import { ContentfulService } from 'src/services/contentful.service';

@Component({
  selector: 'inter-calling-price-table',
  templateUrl: './price-table.component.html',
  styleUrls: ['./price-table.component.scss']
})
export class PriceTableComponent implements OnInit, OnDestroy {
  regions: string[];
  selectedRegion: string;
  public countryNamePattern: RegExp = new RegExp('^[A-Za-z]*$');
  public showValidationError = false;
  countries: {
    metadata: {
      tags: any[];
    };
    sys: {
      space: {
        sys: {
          type: string;
          linkType: string;
          id: string;
        };
      };
      id: string;
      type: string;
      createdAt: string;
      updatedAt: string;
      environment: {
        sys: {
          id: string;
          type: string;
          linkType: string;
        };
      };
      revision: number;
      contentType: any;
      locale: string;
    };
    fields: any;
  }[];
  internationalCountriesContent;
  splitLimit = 8;
  config: PaginationInstance = {
    id: 'countries',
    itemsPerPage: 12,
    currentPage: 1,
    totalItems: 0
  };
  contentfulSubscription: Subscription;
  @Input() categoryId: string;
  @Input() valueTitle: string;
  @Input() inModal: boolean;
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  constructor(private contentfulService: ContentfulService, private appState: AppState) { }

  ngOnDestroy(): void {
    this.contentfulSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.config.id = `${this.config.id}-${this.categoryId}`;

    this.appState.loading = true;
    this.contentfulSubscription = this.contentfulService.getInternationalCallingContentByCategory('internationalCallingCategories', this.config.itemsPerPage, this.categoryId).subscribe({
      next: res => {
        this.countries = res[0].fields.countries;
        this.regions = this.countries.map(country =>
          country.fields.countryRegion
        );
        const regionsSet: Set<any> = new Set(this.regions);
        this.regions = Array.from(regionsSet.values());
        this.regions.sort((a, b) => a.localeCompare(b));
        this.regions.unshift("All");
        this.internationalCountriesContent = res;
        this.selectedRegion = 'All';
        this.config.totalItems = this.countries.length;
        this.appState.loading = false;
      },
      error: _ => {
        this.appState.loading = false;
      }
    });
  }

  search(text: string) {
    this.showValidationError = !this.countryNamePattern.test(text); 
    if (this.showValidationError) {
      this.countries = [];
      return;
    }

    this.countries = this.internationalCountriesContent[0].fields.countries.filter(country =>
      (this.selectedRegion.toLowerCase().trim() == 'all'
        || (country.fields.countryRegion as string).trim().toLowerCase().includes(this.selectedRegion.trim().toLowerCase()))
      && (country.fields.countryName as string).trim().toLowerCase().includes(text.trim().toLowerCase()));
    this.config.currentPage = 1;
  }

  public pageChanged(config: PaginationInstance): void {
    if (config.currentPage > 0 && config.currentPage <= this.countries.length) {
      this.config.currentPage = config.currentPage;
    }
  }

  selectRegion(region: string) {
    this.selectedRegion = region;
    this.resetSearch();
    if (region.toLowerCase().trim() == 'all') {
      this.countries = this.internationalCountriesContent[0].fields.countries.slice();
      return;
    }
    this.countries = this.internationalCountriesContent[0].fields.countries.filter(country => (country.fields.countryRegion as string).trim().toLowerCase().includes(region.trim().toLowerCase()));
    this.config.currentPage = 1;
  }

  resetSearch() {
    this.searchInput.nativeElement.value = '';
    this.search('');
  }

  resetAllFilters() {
    this.resetSearch();
    this.selectRegion('All');
  }
}
